module.exports = __webpack_public_path__ + "img/Camera2.a6616635.png";